export const API_URL = `https://www.ambitas.sk/en/api/v1`

export const FOOTER_ID = 'footer-section'

export const BREAKPOINTS = {
  desktop: 992,
}
